import { render, staticRenderFns } from "./DocumentApprove.vue?vue&type=template&id=ccd1b992&"
import script from "./DocumentApprove.vue?vue&type=script&lang=js&"
export * from "./DocumentApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports